import { render, staticRenderFns } from "./SubsClaim.vue?vue&type=template&id=53bec41a&scoped=true"
import script from "./SubsClaim.vue?vue&type=script&lang=js"
export * from "./SubsClaim.vue?vue&type=script&lang=js"
import style0 from "./SubsClaim.vue?vue&type=style&index=0&id=53bec41a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bec41a",
  null
  
)

export default component.exports